import confetti from "canvas-confetti";

/**
 * Fire a celebratory confetti burst.
 * Colors auto-pick from theme if not supplied.
 */
export const burstConfetti = (colors) => {
  const palette = colors && colors.length ? colors : ["#E11D48", "#22C55E", "#F5D061", "#22D3EE", "#A78BFA"];
  const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return;
  const duration = 1300;
  const end = Date.now() + duration;
  const defaults = { startVelocity: 38, spread: 360, ticks: 60, zIndex: 1000, colors: palette };
  const frame = () => {
    confetti({ ...defaults, particleCount: 4, origin: { x: Math.random(), y: 0.1 + Math.random() * 0.2 } });
    confetti({ ...defaults, particleCount: 3, origin: { x: Math.random(), y: 0.1 + Math.random() * 0.2 } });
    if (Date.now() < end) requestAnimationFrame(frame);
  };
  frame();
  // Initial big burst
  confetti({ particleCount: 120, spread: 80, startVelocity: 55, origin: { y: 0.3 }, colors: palette, zIndex: 1000 });
};

export default burstConfetti;
